var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 8.25C13.1625 8.25 13.5 8.5875 13.5 9C13.5 9.4125 13.1625 9.75 12.75 9.75C12.3375 9.75 12 9.4125 12 9C12 8.5875 12.3375 8.25 12.75 8.25ZM12.75 6.75C11.505 6.75 10.5 7.755 10.5 9C10.5 10.245 11.505 11.25 12.75 11.25C13.995 11.25 15 10.245 15 9C15 7.755 13.995 6.75 12.75 6.75ZM6 1.5H2.25V3H6V1.5ZM11.25 0.75H9V2.25H11.25V4.2375L8.625 7.5H6V3.75H3C1.3425 3.75 0 5.0925 0 6.75V9H1.5C1.5 10.245 2.505 11.25 3.75 11.25C4.995 11.25 6 10.245 6 9H9.375L12.75 4.7625V2.25C12.75 1.85218 12.592 1.47064 12.3107 1.18934C12.0294 0.908035 11.6478 0.75 11.25 0.75ZM3.75 9.75C3.3375 9.75 3 9.4125 3 9H4.5C4.5 9.4125 4.1625 9.75 3.75 9.75Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScooter);
export default __webpack_public_path__ + "static/media/scooter.ac5a0baff3cbbaa5509437c83a2eacfa.svg";
export { ForwardRef as ReactComponent };